import { render, staticRenderFns } from "./AbsencesEditorFinish.vue?vue&type=template&id=28a6a867&scoped=true&lang=pug&"
import script from "./AbsencesEditorFinish.vue?vue&type=script&lang=ts&"
export * from "./AbsencesEditorFinish.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesEditorFinish.vue?vue&type=style&index=0&id=28a6a867&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6a867",
  null
  
)

export default component.exports